import gql from 'graphql-tag';

export default gql(`
	query license_plate( $license_plate: String!, $timeslot_guid: String ) {
		license_plate( license_plate: $license_plate, timeslot_guid: $timeslot_guid ) {
			created_at
			license_plate
			car_type
			car_fuel_type
			car_length
			car_width
			car_height
			car_wheelbase
			car_weight
			is_valid
			limitation_errors
			limitation_warnings
		}
	}
`);

